import DataProvider from './DataProvider'
import { CaseUserAssignment } from './CoursesService'

export type FileRecord = {
    id: Number,
    originalFileName: string
}

export type Answer = {
    id: number;
    text: string;
    image: FileRecord;
    weight: Number;
    date: Date;
    isOptional: boolean;
}

export type Question = {
    id: number;
    questionId: String;
    title: String;
    date: Date;
    theme: {

    }

    text: string;
    allowMultiple: boolean;
    allowOptional: boolean;
    
    image: FileRecord;
    
    answers: Array<Answer>;
}

export type Hint = {    
    text: string;
    image: FileRecord;
    imageData: String;
}

export enum ScenarioItemType {
    HINT = 'HINT',
    QUESTION = 'QUESTION',
    RESULT = 'RESULT'
}

export type Result = {
    courseUserAssignemt: CaseUserAssignment
}

export type ScenarioItem = {
    scenarioItemType: ScenarioItemType,
    scenarioItem: Question|Hint|Result
}

const ENTITY_LEARNING = 'learning'

class Learning {
    public static async getCurrentItem(assignmentId: Number): Promise<ScenarioItem> {
        const res = await DataProvider.executeAction(ENTITY_LEARNING, 'getCurrentScenarioItem', assignmentId);
        return res.result as ScenarioItem;
    }
    
    public static async sendAnswers(assignmentId: Number, answerIds: number[], optionalAnswers: string[]) {
        const res = await DataProvider.executeAction(ENTITY_LEARNING, 'scenarioAnswer', {
            caseUserAssignmentId: assignmentId,
            answerIds,
            optionalAnswers: optionalAnswers.map(m => m.trim()).filter(f => f.length)
        });
        if (res.error || res.errorCode) {
            console.log("Error sendeing answers", res.err);
            throw new Error(res.error);
        }
    }
    
    public static async hintAccepted(assignmentId: Number) {
        const res = await DataProvider.executeAction(ENTITY_LEARNING, 'scenarioHintAccepted', assignmentId);
        if (res.error || res.errorCode) {
            console.log("Error hint accept", res.err);
            throw new Error(res.error);
        }
    }

    public static async getLearningHistory(courseUserAssignmentId: number) {
        let res = await DataProvider.executeAction("learning", "getHistory", courseUserAssignmentId);
        if (res.error || res.errorCode) {
            console.log("Error hint accept", res.err);
            throw new Error(res.error);
        } else {
            return res.data;
        }
    }
}

export default Learning;